import { useEffect, useState, useCallback } from 'react';
import { localStorage as dibsLocalStorage } from 'dibs-browser-storage';

const STORAGE_KEY = 'media_dark_mode';

export function useMediaDarkMode(isFullscreen?: boolean): [boolean, () => void] {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        const storageValue = dibsLocalStorage.getItem(STORAGE_KEY);
        setIsDarkMode(!!storageValue);
    }, []);

    // currently darkmode is only available on fullscreen
    useEffect(() => {
        if (!isFullscreen) {
            setIsDarkMode(false);
        } else {
            const latestPreference = dibsLocalStorage.getItem(STORAGE_KEY);
            setIsDarkMode(!!latestPreference);
        }
    }, [isFullscreen]);

    const toggleDarkMode = useCallback(() => {
        setIsDarkMode(currentValue => {
            dibsLocalStorage.setItem(STORAGE_KEY, !currentValue);
            return !currentValue;
        });
    }, []);

    return [isDarkMode, toggleDarkMode];
}
